import { COLORS } from '@/constants';
import styled from 'styled-components';

export const StatsWrapper = styled.div<{ $inline?: boolean }>`
  display: ${({ $inline }) => ($inline ? 'flex' : 'grid')};
  ${({ $inline }) => $inline && 'flex-wrap: wrap;'}
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  align-items: start;
  border: 1px solid #ebebeb;
  border-radius: 6px;
  padding: 10px;
  background: ${COLORS['neutral/50']};
`;

export const StatItem = styled.div<{ $break?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1 1 auto;
  ${({ $break }) => $break && 'grid-column: 1 / -1; flex-basis: 100%; flex: 0 0 auto;'}
`;
